import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";

import TodayBirthdays from "./TodayBirthdays";
import WelcomeNewEmployees from "./WelcomeNewEmployees";
import WorkAnniversary from "./WorkAnniversary";

const TodayOverview = () => {
  const [leaveToday, setLeaveToday] = useState([]);
  const [birthdays, setBirthdays] = useState([]);
  const [newEmployees, setNewEmployees] = useState([]);
  const [anniversaryEmployees, setAnniversaryEmployees] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const headers = { Authorization: `Bearer ${token}` };

    const fetchData = async () => {
      try {
        const [
          leaveRes,
          birthdayRes,
          newEmpRes,
          anniversaryRes,
        ] = await Promise.all([
          axios.get(`${API_BASE_URL}/depttoday-leaves`, { headers }),
          axios.get(`${API_BASE_URL}/depttoday-birthdays`, { headers }),
          axios.get(`${API_BASE_URL}/deptwelcome-new-employees`, { headers }),
          axios.get(`${API_BASE_URL}/depttoday-anniversaries`, { headers }),
        ]);

        setLeaveToday(leaveRes.data || []);
        setBirthdays(birthdayRes.data || []);
        setNewEmployees(newEmpRes.data || []);
        setAnniversaryEmployees(anniversaryRes.data || []);
      } catch (error) {
        console.error("Today overview fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="p-3">Loading...</div>;
  }

  return (
    <div className="section-body">
      <div className="container-fluid">

        <div className="card mb-3">
          <div className="card-header d-flex justify-content-between align-items-center">
        <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
            <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/><path d="M5.216 14A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.75 8a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5"/>
          </svg>
          My Team
        </h3>
          </div>
        </div>

        {/* ================= ROW 1 ================= */}
        <div className="row">

          {/* ================= ON LEAVE TODAY ================= */}
         {/* ================= ON LEAVE TODAY ================= */}
<div className="col-md-6 mb-3">
  <div className="card anniversary-card">

    {/* HEADER — SAME AS WORK ANNIVERSARY */}
   
<div className="card-header birthday-snow-header">
        <h5 className="card-title mb-0">  On Leave Today (Your Team)</h5>
      </div>

    {/* BODY — SAME SCROLL CLASS */}
    <div className="card-body p-2 birthday-scroll-manual">
      {leaveToday.length === 0 ? (
        <div className="text-muted text-center py-3">
          🎉 Hooray, no team member is on leave today!
        </div>
      ) : (
        leaveToday.map((emp, index) => (
          <div
            className="anniversary-row d-flex align-items-center justify-content-between"
            key={index}
          >
            {/* LEFT */}
            <div className="d-flex align-items-center gap-2">
              <div className="anniversary-info">
                <div className="anniversary-name">
                  {emp.employee_name}
                </div>
                <div className="anniversary-department">
                  {emp.department}
                </div>
              </div>
            </div>

            {/* RIGHT */}
            <span className="badge bg-success">
              {emp.leave_type}
            </span>
          </div>
        ))
      )}
    </div>

  </div>
</div>



          {/* ================= TODAY BIRTHDAYS ================= */}
          <div className="col-md-6 mb-3">
            <TodayBirthdays birthdays={birthdays} />
          </div>

        </div>

        {/* ================= ROW 2 ================= */}
        <div className="row">

          {/* ================= WORK ANNIVERSARY ================= */}
          <div className="col-md-6 mb-3">
            <WorkAnniversary employees={anniversaryEmployees} />
          </div>

          {/* ================= WELCOME NEW EMPLOYEES ================= */}
          <div className="col-md-6 mb-3">
            <WelcomeNewEmployees employees={newEmployees} />
          </div>

        </div>

      </div>
    </div>
  );
};

export default TodayOverview;
